import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Row, Space, Select, Form } from 'antd';
import {
  getCommunities,
  getCommunityResources
} from '../../services/communityService';
import Title from 'antd/es/typography/Title';
import CommunityResourceTable from './components/CommunityResourceTable';
import AddCommunityResource from './components/AddCommunityResource';
import { useForm } from 'antd/lib/form/Form';
const { Option } = Select;

const CommunityResourceListPage = () => {
  const [totalData, setTotalData] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [resources, setResources] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [resourcesLoaded, setResourcesLoaded] = useState(false);
  const [communitiesLoaded, setCommunitiesLoaded] = useState(false);
  const [visibleAddModal, setVisibleAddModal] = useState(false);
  const [filters, setFilters] = useState({ communityObjectId: null });
  const [form] = useForm();

  const onClickModal = () => {
    setVisibleAddModal(true);
  };

  const onCancelModal = () => {
    setVisibleAddModal(false);
  };

  const resetForm = () => {
    form.resetFields();
    form.submit();
  };

  const allDataLoaded = communitiesLoaded && resourcesLoaded;

  const getCommunityResourceList = useCallback(async () => {
    setResourcesLoaded(false);
    return await getCommunityResources({ pageSize, pageNo, ...filters })
      .then((response) => {
        const data = response.data;
        const resourcesList = data.paginatedList;
        setResources(resourcesList);
        setTotalData(data.totalCount);
        setResourcesLoaded(true);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  }, [filters, pageNo, pageSize]);

  const getCommunityList = useCallback(
    async () =>
      getCommunities({ pageSize: 10000, pageNo: 1 })
        .then((response) => {
          const communities = response?.data?.paginatedList.sort(
            (communityA, communityB) =>
              communityA?.title?.localeCompare(communityB?.title)
          );
          setCommunities(communities);
          setCommunitiesLoaded(true);
        })
        .catch((error) => {
          console.log(
            'Error getting communities list from the admin backend:',
            error
          );
          alert('Getting communities list from the backend failed!');
        }),
    []
  );

  const onPaginationChange = (data) => {
    setPageNo(data.current);
    setPageSize(data.pageSize);
  };

  useEffect(() => {
    getCommunityList();
  }, [getCommunityList]);

  useEffect(() => {
    getCommunityResourceList();
  }, [getCommunityResourceList]);

  return (
    <div>
      <div>
        <Space size="large">
          <Title level={3} style={{ width: 300 }}>
            Community Resources
          </Title>
          <Button type="ghost" onClick={onClickModal}>
            Add
          </Button>
        </Space>

        <Form form={form} onFinish={(values) => setFilters(values)}>
          <Row justify="space-between" align="center">
            <Col>
              <Title level={5}>Filters</Title>
            </Col>
            <Col>
              <Row gutter={16}>
                <Col>
                  <Form.Item name="communityObjectId">
                    <Select placeholder="Select Community Code">
                      {communities?.map((option, index) => (
                        <Option key={index} value={option?._id}>
                          {option?.title}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col>
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Col>
                <Col>
                  <Button htmlType="button" onClick={resetForm}>
                    Clear
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>

        <Title level={5}>Total {totalData} Record(s)</Title>
        <section>
          <CommunityResourceTable
            loading={!allDataLoaded}
            data={resources}
            communities={communities}
            totalData={totalData}
            onPaginationChange={onPaginationChange}
          />
        </section>

        <AddCommunityResource
          isOpen={visibleAddModal}
          onCancelModal={onCancelModal}
        />
      </div>
    </div>
  );
};

export default CommunityResourceListPage;
